import { render } from "./ComboChipsBox.vue?vue&type=template&id=5f8fb9a5&lang=pug"
import script from "./ComboChipsBox.vue?vue&type=script&lang=js"
export * from "./ComboChipsBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__